export default __webpack_public_path__ + "static/media/overview_target.e5deffbd.png";